import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo, PageLoader } from "../components/shared";
import api from "../lib/api";

export default function LegalPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setDoc(null)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background">
      <header className="mx-auto max-w-3xl px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/"><Logo /></Link>
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft size={16} /> Home</Link>
      </header>
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-10">
        {loading ? <PageLoader /> : !doc ? (
          <p className="text-muted-foreground">Document not found.</p>
        ) : (
          <article>
            <div className="overline mb-2">Legal · v{doc.version} · Effective {doc.effective_date}</div>
            <h1 className="font-heading text-4xl font-semibold tracking-tight mb-6">{doc.title}</h1>
            <div className="prose prose-zinc max-w-none text-foreground/90 leading-relaxed [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1 [&_p]:mt-4"
              dangerouslySetInnerHTML={{ __html: doc.content }} />
          </article>
        )}
      </div>
    </div>
  );
}
